export const ROUTES = {
  ROOT: '/',
  SIGN_IN: '/signin',
  SCENARIO_DASHBOARD: '/scenario-dashboard',
}